import { RadioItemListCombinedProps } from './types';

const usePresenter = (props: RadioItemListCombinedProps): RadioItemListCombinedProps => {
  return props;
};

export default usePresenter;
